import React from "react";

const setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

const getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
};

export default class CookieAccept extends React.Component {
  constructor(props) {
    super(props);
    this.accept = this.accept.bind(this);
  }

  accept() {
    setCookie("COOKIEACCEPT", 1, 60);
    this.forceUpdate();
  }

  render() {
    if (getCookie("COOKIEACCEPT") !== undefined) return null;

    return (
      <div className="cookie-alert-container">
        <div>
          <div id="cookie-text">Diese Webseite benutzt Cookies um das Nutzerverhalten zu verbessern.</div>
          <button id="cookie-close" className="default-button" onClick={this.accept}>
            Akzeptieren
          </button>
        </div>
      </div>
    );
  }
}
